import React, { Suspense, lazy } from "react";
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import reducers from './common/redux/reducers';
import './assets/scss/style.scss';
import { actionGetConfigSettings } from "./common/redux/actions";
const SpikeViewRoute = lazy(() => import("./route/SpikeViewRoute"));
const store = createStore(reducers, {}, applyMiddleware(reduxThunk)); 
store.dispatch(actionGetConfigSettings());

ReactDOM.render(  
  <BrowserRouter>
    <Provider store={store}> 
      <Suspense fallback={<div></div>}>
        <SpikeViewRoute />
      </Suspense>      
    </Provider>
  </BrowserRouter>,
  document.getElementById('root') 
);

reportWebVitals();
serviceWorker.unregister();
